import { Roles } from 'src/shared/enums';
import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';

export const usersPaths = {
	default: '',
	root: 'users',
	adminUserList: 'admin-user-list',
	customerUserList: 'customer-user-list',
	registrationRequestList: 'registration-request-list',
	adminUserDetail: 'admin-user/:id',
	customerUserDetail: 'customer-user/:id',
	addCustomerUser: 'add-customer-user',
};

export const usersFragments = {
	default: [usersPaths.default],
	root: [usersPaths.default, usersPaths.root],
	adminUserList: [
		usersPaths.default,
		usersPaths.root,
		usersPaths.adminUserList,
	],
	customerUserList: [
		usersPaths.default,
		usersPaths.root,
		usersPaths.customerUserList,
	],
	registrationRequestList: [
		usersPaths.default,
		usersPaths.root,
		usersPaths.registrationRequestList,
	],
	adminUserDetail: (id: string) =>
		id ? [usersPaths.default, usersPaths.root, 'admin-user', id] : null,
	customerUserDetail: (id: string) =>
		id ? [usersPaths.default, usersPaths.root, 'customer-user', id] : null,
	addCustomerUser: [
		usersPaths.default,
		usersPaths.root,
		usersPaths.addCustomerUser,
	],
};

export const usersDefaultAuthRoles = [Roles.Admin, Roles.HR];

export const usersDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: { roles: usersDefaultAuthRoles },
};
